export default "__VITE_ASSET__DDYddxFA__"